import { createContext } from 'react';
import { IFormStructure, IMedia } from '../schema/interface';

const FormStructureContext = createContext({
    fetchedFormStructure: null,
    setFormStructure: (value: IFormStructure) => {
        value;
    },
    errorMessage: null,
    setErrorMessage: (err: string) => {
        err;
    },
    media: null,
    setMedia: (value: IMedia) => {
        value;
    }
});

export default FormStructureContext;
